import React from "react";
import { Alert } from "@mui/material";

export const ErrorAlert = ({ error, onClose }) => (
  <Alert 
    severity="error" 
    onClose={onClose}
    sx={{ borderRadius: 1 }}
  >
    {error}
  </Alert>
);